


















import {Component, Prop, Vue} from "vue-property-decorator";
import {IMenuEntity} from "@/model/menu/IMenuEntity";
import {IMenuBaseEntity} from "@/model/menu/IMenuBaseEntity";

@Component
export default class BaseMenuEntity extends Vue {
    @Prop() menu!: IMenuEntity;
    @Prop( { default: false } ) isRightSection!: boolean;

    isRouteActive(eachMenu: IMenuEntity): boolean {
        const isItself = eachMenu.name === this.$route.name;
        const isInSubMenus = this.isSubMenuRouteActive(eachMenu);
        const isInRoutes = eachMenu.routes && eachMenu.routes.some( (eachSubMenu) => eachSubMenu.name === this.$route.name );
        return isItself || isInSubMenus || isInRoutes;
    }

    isSubMenuRouteActive(eachMenu: IMenuBaseEntity): boolean {
        if ( !eachMenu.subMenus || eachMenu.subMenus.length === 0 ) return false;

        return eachMenu.subMenus && eachMenu.subMenus.some( (eachSubMenu) => {
            if ( eachSubMenu.name === this.$route.name )
                return true;

            return this.isSubMenuRouteActive(eachSubMenu);
        } );
    }

    isMenuHasSubMenus(menuItem: IMenuEntity): boolean {
        return menuItem.subMenus && menuItem.subMenus.some( (eachSubMenu) => {
            return eachSubMenu.subMenus && eachSubMenu.subMenus.length > 0;
        } );
    }
}
